import React from 'react'
import { Link } from 'react-router-dom'
import placeholderImg from '../../asset/ghumneplaceholder.jpg'
import { truncate } from '../../../utils'
const BlogCard = (items) => {
  const { title, img, desc, border,slug } = items


  function createMarkup(content) {
    const sanitizedContent = content?.replace(/<p>&nbsp;<\/p>*>/g, "");
    return { __html: sanitizedContent };
  }

  const borderStyle = {
    "border": `1px solid ${border}`
  }

  return (
    <>
      <div className="location_card rounded-3 p-2" style={borderStyle}>
        <div className="locatione_img overflow-hidden rounded-3">
          <img src={img} alt={title} className='w-100 h-100 object-fit-fill' onError={(e) => (e.target.src = placeholderImg)} />
        </div>
        <div className="location_content blog-content position-relative">
          <div className='d-flex justify-content-between align-items-center mb-2'>
            <h6 className='title text-capitalize fw-semibold mt-2 mb-0 text-black'>{truncate(title, 8)}</h6>
          </div>
          <div className='mb-3 text-black'>
            <p dangerouslySetInnerHTML={createMarkup(truncate(desc, 8))}></p>
          </div>
          <Link to={`/blogs/${slug}`} className='text-white text-decoration-none px-3 py-1 rounded-2 read_more_btn position-absolute bottom-0'>Read Full Story</Link>
        </div>
      </div>
    </>
  )
}

export default BlogCard